module.exports = "/static-assets/_next/static/images/Jeff-e2511250a6e44a2036d8bab51ea9f42b.png";